import { render } from "./CollapseTarget.vue?vue&type=template&id=843c850a&scoped=true"
import script from "./CollapseTarget.vue?vue&type=script&lang=js"
export * from "./CollapseTarget.vue?vue&type=script&lang=js"

import "./CollapseTarget.vue?vue&type=style&index=0&id=843c850a&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-843c850a"]])

export default __exports__